<template>
  <div class="popupContainer" @click="onCloseModal">
    <div class="mobile-premium-modal-container" @click.stop @touchstart="handleTouchStart" @touchend="handleTouchEnd">
      <div class="mobile-premium-modal-title">{{ $t('camstudy.premiumPlusDescriptionModal.title') }}</div>
      <div v-html="mobilePremiumItemTitle" class="mobile-premium-item-title"></div>
      <div class="mobile-premium-background-image" :class="backgroundClass"></div>
      <div v-if="currentTab >= 3" class="absolute premium-background">
        <div class="premium-background-text">Premium+ <br />Only!</div>
      </div>
      <div class="mobile-premium-feature-description" v-html="mobilePremiumDescription"></div>
      <div class="mobile-premium-select-item-container">
        <button class="previous-item-button" @click="onPreviousButton"></button>
        <div class="item-select-list">
          <div v-for="item in 6" :key="item" class="item-select" :class="{select: item-1 === currentTab}" @click="() => onSelectButton(item-1)"></div>
        </div>
        <button class="next-item-button" @click="onNextButton"></button>
      </div>
      <div class="control-button-container">
        <button v-if="!isCreateStudy" class="control-button" @click="onCloseForever">7일간 보지 않기</button>
        <button v-if="isFreeRoom" class="control-button ok free" @click="onMoveShop">프리미엄+ 이용권 구매하기</button>
        <button v-else class="control-button ok" @click="onCloseModal">확인</button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'PremiumPlusModal',
  data() {
    return {
      currentTab: 0,
      mobilePremiumTitle: [
        this.$t('camstudy.premiumPlusDescriptionModal.content.item1'),
        this.$t('camstudy.premiumPlusDescriptionModal.content.item2'),
        this.$t('camstudy.premiumPlusDescriptionModal.content.item3'),
        this.$t('camstudy.premiumPlusDescriptionModal.content.item4'),
        this.$t('camstudy.premiumPlusDescriptionModal.content.item5'),
        this.$t('camstudy.premiumPlusDescriptionModal.content.item6'),
      ],
      touchStartX: 0,
      touchEndX: 0,
    }
  },
  props: {
    isCreateStudy: Boolean
  },
  watch: {
  },
  computed: {
    ...mapGetters('room', [
      'room',
    ]),
    mobilePremiumDescription(){
      return this.mobilePremiumTitle[this.currentTab];
    },
    backgroundClass(){
      return `image${this.currentTab+1}`
    },
    mobilePremiumItemTitle(){
      const titleArray = [
        this.$t('camstudy.premiumPlusDescriptionModal.list.item1'),
        this.$t('camstudy.premiumPlusDescriptionModal.list.item2'),
        this.$t('camstudy.premiumPlusDescriptionModal.list.item3'),
        this.$t('camstudy.premiumPlusDescriptionModal.list.item4'),
        this.$t('camstudy.premiumPlusDescriptionModal.list.item5'),
        this.$t('camstudy.premiumPlusDescriptionModal.list.item6'),
      ]
      return titleArray[this.currentTab]
    },
    isFreeRoom() {
      return this.room?.roomLevel === 'FREE_PLUS';
    }
  },
  created () {
  },
  mounted() {
  },
  methods: {
    onCloseModal(){
      this.$emit('close')
    },
    onPreviousButton(){
      if(this.currentTab === 0){
        this.currentTab = 5;
        return;
      }
      this.currentTab -= 1;
    },
    onNextButton(){
      if(this.currentTab === 5){
        this.currentTab = 0;
        return;
      }
      this.currentTab += 1;
    },
    onSelectButton(value) {
      this.currentTab = value;
    },
    handleTouchStart(e) {
      this.touchStartX = e.changedTouches[0].screenX;
      document.body.style.overflow = 'hidden';
    },
    handleTouchEnd(e) {
      this.touchEndX = e.changedTouches[0].screenX;
      this.handleSwipeGesture();
      document.body.style.overflow = 'auto';
    },
    handleSwipeGesture() {
      const diff = this.touchEndX - this.touchStartX;
      if (Math.abs(diff) < 30) return;

      if (diff > 0) {
        this.onPreviousButton();
      } else {
        this.onNextButton();
      }
    },
    onCloseForever(){
      // localStorage.setItem('premium-plus-close-forever', true)
      const days = 7;
      const expires = new Date(Date.now() + days * 864e5).toUTCString(); // 864e5 = 86400000ms = 1일
      document.cookie = `premium_plus_close_forever=true; expires=${expires}; path=/`;
      this.onCloseModal()
    },
    onMoveShop(){
      const env = process.env.NODE_ENV;
      if(env === 'development') {
        window.open('https://cams-dev.gooroomee.com/camstudy/shop', '_blank');
      }else if(env === 'production') {
        window.open('https://gooroomee.com/camstudy/shop', '_blank');
      }
    }
  }
}
</script>

<style scoped lang="scss">
[grm-device-mobile]{
  @media(orientation: landscape) {
    .mobile-premium-modal-container{
      max-height: 100%;
      overflow: scroll;
    }
  }
  @media(orientation: portrait) {
    .mobile-premium-modal-container{
      min-height: 500px;
    }
  }
}
html:not([grm-device-mobile]){
  .mobile-premium-modal-container{
    min-height: 500px;
  }
}
.mobile-premium-modal-container{
  z-index: 3;
  max-width: 380px;
  width: 100%;
  max-height: 100%;
  border-radius: 12px;
  background: #FFF;
  box-shadow: 0 7px 21px -7px rgba(0, 0, 0, 0.06), 0 28px 56px 0 rgba(0, 0, 0, 0.08);

  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);


  .mobile-premium-modal-title{
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    line-height: 150%;

    margin-top: 30px;
    background: linear-gradient(90deg, #0069FF 0.01%, #0560E3 0.44%, #4299FF 100%);
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
  }
  .mobile-premium-item-title{
    color: #000;
    text-align: center;
    font-size: 20px;
    font-weight: 700;
    line-height: 150%;
    margin-top: 6px;
  }
  .mobile-premium-modal-nav-ul{
    margin-top: 24px;
    display: flex;
    justify-content: space-between;
    padding: 0 30px;
    .mobile-premium-modal-nav-li {
      padding: 0 4px 10px 4px;
      text-align: center;
      font-size: 12px;
      font-weight: 700;
      line-height: 150%;
      color: #BDBDBD;
      cursor: pointer;

      &.active {
        color: #000;
        border-bottom: 2px solid #016FF2;
      }
    }
  }
  .mobile-premium-background-image{
    width: 100%;
    aspect-ratio: 380 / 254;

    margin: 24px 0;

    &.image1{
      background: url("~@/assets/images/camstudy/mobile_premium_feature_001.jpg") no-repeat;
      background-size: auto 240px;
    }
    &.image2{
      background: url("~@/assets/images/camstudy/mobile_premium_feature_002.jpg") no-repeat;
      background-size: auto 240px;
    }
    &.image3{
      background: url("~@/assets/images/camstudy/mobile_premium_feature_003.jpg") no-repeat;
      background-size: auto 240px;
    }
    &.image4{
      background: url("~@/assets/images/camstudy/mobile_premium_feature_004.jpg") no-repeat;
      background-size: auto 240px;
    }
    &.image5{
      background: url("~@/assets/images/camstudy/mobile_premium_feature_005.jpg") no-repeat;
      background-size: auto 240px;
    }
    &.image6{
      background: url("~@/assets/images/camstudy/mobile_premium_feature_006.jpg") no-repeat;
      background-size: auto 240px;
    }
  }
  .mobile-premium-feature-description{
    text-align: center;
    color: #000;
    font-size: 14px;
    line-height: 150%;
    min-height: 84px;
    padding: 0 36px;
  }
  .mobile-premium-select-item-container{
    margin-top: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .previous-item-button{
      width: 50px;
      height: 50px;
      background: url("~@/assets/images/camstudy/ico_arrowRight_gray.svg") no-repeat center center;
      transform: rotate(180deg);
    }
    .next-item-button{
      width: 50px;
      height: 50px;
      background: url("~@/assets/images/camstudy/ico_arrowRight_gray.svg") no-repeat center center;
    }
    .item-select-list{
      display: flex;
      align-items: center;
      gap: 6px;

      .item-select{
        width: 8px;
        height: 8px;
        background: rgba(0,0,0,0.2);
        border-radius: 50%;


        &.select{
          background: #016FF2;
        }
      }
    }
  }
  .control-button-container{
    display: flex;
    border-top: 0.333px solid rgba(0, 0, 0, 0.20);
    border-radius: 0 0 12px 12px;
    overflow: hidden;

    .control-button{
      width: 100%;
      font-size: 14px;
      line-height: 150%;
      padding: 15px 0 14px 0;
      background: white;
      &.ok{
        font-weight: 700;
      }
      &.free{
        color: #0069FF;
      }
    }
  }
}
.premium-background{
  right: 14px;
  top: 100px;
  width: 81px;
  height: 81px;
  background: url("~@/assets/images/camstudy/premium_background.png") no-repeat center center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  .premium-background-text{
    text-align: center;
    transform: rotate(15deg);
    text-shadow: 0 3px 10px rgba(5, 114, 243, 0.15);
    font-size: 12px;
    font-weight: 700;
    line-height: 120%;
    color: #FFF;
  }
}
</style>